import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';

const Store = () => {
  const [activeTab, setActiveTab] = useState('virtual-training');
  const [isProcessing, setIsProcessing] = useState(false);

  // Auth-gating is handled by <ProtectedRoute> at the route level.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const storeCategories = [
    {
      id: 'virtual-training',
      name: 'Virtual Training Sessions',
      description: 'One-on-one coaching with certified instructors via Zoom',
      packages: [
        {
          id: 'training-3month',
          name: '30-Min Virtual Training',
          price: 49.99,
          bonus: '3 Months Free Premium',
          duration: '30 minutes',
          features: [
            'One-on-one virtual coaching session',
            'Personalized technique assessment',
            'Custom training plan creation',
            'Video analysis of your form',
            'Q&A with certified instructor',
            'BONUS: 3-month Premium Access'
          ]
        },
        {
          id: 'training-1year',
          name: '45-Min Virtual Training',
          price: 99.99,
          bonus: 'Free Premium for 1 Year',
          popular: true,
          duration: '45 minutes',
          features: [
            'One-on-one virtual coaching session',
            'Personalized technique assessment',
            'Custom training plan creation',
            'Video analysis of your form',
            'Q&A with certified instructor',
            'Follow-up email support (2 weeks)',
            'BONUS: Full year Premium Access'
          ]
        }
      ]
    }
    // {
    //   id: 'range-day',
    //   name: 'Range Day Experiences',
    //   description: 'Full-day in-person training at the range with expert instruction',
    //   packages: [
    //     {
    //       id: 'range-day-basic',
    //       name: 'Range Drills Range Day Experience',
    //       price: 250.00,
    //       bonus: '6 Months Free Premium',
    //       popular: true,
    //       features: [
    //         'Full day at the range (6 hours)',
    //         'In-person expert instruction',
    //         'Personal equipment assessment',
    //         'Live fire drills and feedback',
    //         'Lunch and refreshments included',
    //         'Group photos and videos',
    //         'BONUS: 6-month Premium Access'
    //       ]
    //     }
    //   ]
    // },
    // {
    //   id: 'merchandise',
    //   name: 'Range Drills Merchandise',
    //   description: 'Exclusive apparel and gear for serious shooters',
    //   packages: [
    //     {
    //       id: 'tshirt',
    //       name: 'Range Drills T-Shirt',
    //       price: 29.99,
    //       bonus: '1 Month Free Premium',
    //       features: [
    //         'Premium cotton blend',
    //         'Range Drills logo',
    //         'Available in multiple sizes',
    //         'Comfortable fit for range wear',
    //         'BONUS: 1-month Premium Access'
    //       ]
    //     },
    //     {
    //       id: 'hoodie',
    //       name: 'Range Drills Hoodie',
    //       price: 54.99,
    //       bonus: '3 Months Free Premium',
    //       features: [
    //         'Heavy-duty fleece material',
    //         'Range Drills embroidered logo',
    //         'Available in multiple sizes',
    //         'Kangaroo pocket',
    //         'Perfect for outdoor training',
    //         'BONUS: 3-month Premium Access'
    //       ]
    //     }
    //   ]
    // }
  ];

  // Stripe Payment Links mapping
  const stripePaymentLinks = {
    'training-3month': 'https://buy.stripe.com/test_cNi00l4Vjcbd7ZjbP47ok01', // Monthly - $49.99
    'training-1year': 'https://buy.stripe.com/test_cNi7sN73rejlcfz5qG7ok00', // Yearly - $99.99
    // Add more as you create them in Stripe:
    // 'range-day-basic': 'https://buy.stripe.com/test_xxxxx',
    // 'tshirt': 'https://buy.stripe.com/test_xxxxx',
    // 'hoodie': 'https://buy.stripe.com/test_xxxxx',
  };

  const handlePurchase = async (packageId) => {
    setIsProcessing(true);
    
    try {
      const paymentLink = stripePaymentLinks[packageId];
      
      if (!paymentLink) {
        alert('Payment link not configured yet. Please contact info@rangedrills.io');
        setIsProcessing(false);
        return;
      }

      // Redirect to Stripe Payment Link
      window.location.href = paymentLink;
    } catch (error) {
      console.error('Purchase error:', error);
      alert('Error processing purchase. Please try again or contact info@rangedrills.io');
      setIsProcessing(false);
    }
  };

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: "40px" }}>
          <h2 className="major" style={{ textAlign: "center", marginBottom: "0px", paddingBottom: "0px" }}>
            Range Drills Store
          </h2>
          <p style={{ 
            textAlign: "center", 
            fontSize: "1em", 
            opacity: "0.9",
            marginBottom: "20px",
            maxWidth: "600px",
            margin: "0 auto 20px"
          }}>
            Premium training services, exclusive experiences, and more.
          </p>

          {/* Tabs Navigation - Only show if more than 1 category */}
          {storeCategories.length > 1 && (
            <div style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
              flexWrap: "wrap",
              gap: "10px"
            }}>
              {storeCategories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveTab(category.id)}
                  style={{
                    padding: "12px 25px",
                    borderRadius: "8px",
                    border: activeTab === category.id ? "2px solid #FF5722" : "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: activeTab === category.id ? "rgba(255, 87, 34, 0.2)" : "rgba(255, 255, 255, 0.05)",
                    color: "#fff",
                    cursor: "pointer",
                    fontSize: "1em",
                    fontWeight: activeTab === category.id ? "bold" : "normal",
                    transition: "all 0.3s ease",
                    outline: "none"
                  }}
                  onMouseEnter={(e) => {
                    if (activeTab !== category.id) {
                      e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== category.id) {
                      e.target.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                    }
                  }}
                >
                  {category.name}
                </button>
              ))}
            </div>
          )}

          {/* Active Category Content */}
          {(storeCategories.length > 1 
            ? storeCategories.filter(category => category.id === activeTab)
            : storeCategories
          ).map((category) => (
            <div key={category.id}>
              {/* Category Description */}
              <div style={{
                maxWidth: "800px",
                margin: "0 auto 30px",
                textAlign: "center"
              }}>
                <p style={{
                  fontSize: "1.05em",
                  opacity: "0.85",
                  margin: "0"
                }}>
                  {category.description}
                </p>
              </div>

              {/* Category Packages */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "25px",
                maxWidth: "800px",
                margin: "0 auto",
                alignItems: "stretch"
              }}>
                {category.packages.map((pkg) => (
                  <div
                    key={pkg.id}
                    style={{
                      padding: "25px",
                      backgroundColor: "rgba(27, 31, 34, 0.85)",
                      borderRadius: "10px",
                      border: pkg.popular ? "2px solid #FF5722" : "1px solid rgba(255, 255, 255, 0.2)",
                      boxShadow: pkg.popular ? "0 6px 16px rgba(255, 87, 34, 0.3)" : "0 4px 12px rgba(0, 0, 0, 0.2)",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column"
                    }}
                  >
                    {pkg.popular && (
                      <div style={{
                        position: "absolute",
                        top: "-12px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "#FF5722",
                        color: "#fff",
                        padding: "5px 20px",
                        borderRadius: "20px",
                        fontSize: "0.8em",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                      }}>
                        Most Popular
                      </div>
                    )}

                    <h3 style={{
                      marginTop: pkg.popular ? "10px" : "0",
                      marginBottom: "15px",
                      color: "#FF5722",
                      fontSize: "1.3em",
                      textAlign: "center"
                    }}>
                      {pkg.name}
                    </h3>

                    <div style={{
                      textAlign: "center",
                      marginBottom: "20px"
                    }}>
                      <div style={{
                        fontSize: "2.5em",
                        fontWeight: "bold",
                        color: "#FF5722",
                        lineHeight: "1"
                      }}>
                        ${pkg.price}
                      </div>
                      {pkg.duration && (
                        <div style={{
                          fontSize: "0.9em",
                          opacity: "0.8",
                          marginTop: "5px"
                        }}>
                          {pkg.duration} session
                        </div>
                      )}
                    </div>

                    {pkg.bonus && (
                      <div style={{
                        backgroundColor: "rgba(76, 175, 80, 0.2)",
                        border: "1px solid rgba(76, 175, 80, 0.5)",
                        borderRadius: "8px",
                        padding: "12px",
                        marginBottom: "20px",
                        textAlign: "center"
                      }}>
                        <div style={{
                          fontSize: "0.85em",
                          color: "#4CAF50",
                          fontWeight: "bold",
                          marginBottom: "3px"
                        }}>
                          🎁 BONUS INCLUDED
                        </div>
                        <div style={{
                          fontSize: "1.05em",
                          fontWeight: "600",
                          color: "#fff"
                        }}>
                          {pkg.bonus}
                        </div>
                      </div>
                    )}

                    <ul style={{
                      listStyle: "none",
                      padding: "0",
                      marginBottom: "25px",
                      flex: "1"
                    }}>
                      {pkg.features.map((feature, index) => (
                        <li
                          key={index}
                          style={{
                            padding: "8px 0",
                            borderBottom: index < pkg.features.length - 1 ? "1px solid rgba(255, 255, 255, 0.1)" : "none",
                            display: "flex",
                            alignItems: "flex-start",
                            fontSize: "0.9em"
                          }}
                        >
                          <span style={{
                            color: "#4CAF50",
                            marginRight: "8px",
                            fontSize: "1.1em",
                            flexShrink: 0
                          }}>
                            ✓
                          </span>
                          <span style={{ opacity: "0.9" }}>{feature}</span>
                        </li>
                      ))}
                    </ul>

                    <button
                      onClick={() => handlePurchase(pkg.id)}
                      disabled={isProcessing}
                      style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor: isProcessing ? "#999" : "#FF5722",
                        color: "#fff",
                        fontSize: "1em",
                        fontWeight: "bold",
                        cursor: isProcessing ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease",
                        marginTop: "auto",
                        opacity: isProcessing ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => {
                        if (!isProcessing) {
                          e.target.style.backgroundColor = "#e64a19";
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 4px 12px rgba(255, 87, 34, 0.4)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isProcessing) {
                          e.target.style.backgroundColor = "#FF5722";
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "none";
                        }
                      }}
                    >
                      {isProcessing ? 'Processing...' : 'Book Now'}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* How It Works */}
          <div style={{
            maxWidth: "700px",
            margin: "50px auto 40px",
            padding: "25px",
            backgroundColor: "rgba(27, 31, 34, 0.85)",
            borderRadius: "10px",
            border: "1px solid rgba(255, 255, 255, 0.2)"
          }}>
            <h3 style={{
              marginTop: "0",
              marginBottom: "20px",
              color: "#FF5722",
              textAlign: "center",
              fontSize: "1.3em"
            }}>
              How It Works
            </h3>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "20px"
            }}>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2em", marginBottom: "10px" }}>📅</div>
                <div style={{ fontSize: "0.95em", fontWeight: "600", marginBottom: "5px" }}>1. Book</div>
                <div style={{ fontSize: "0.85em", opacity: "0.8" }}>Choose your package and complete payment</div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2em", marginBottom: "10px" }}>📧</div>
                <div style={{ fontSize: "0.95em", fontWeight: "600", marginBottom: "5px" }}>2. Schedule</div>
                <div style={{ fontSize: "0.85em", opacity: "0.8" }}>We'll email you to set up your session</div>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "2em", marginBottom: "10px" }}>💻</div>
                <div style={{ fontSize: "0.95em", fontWeight: "600", marginBottom: "5px" }}>3. Train</div>
                <div style={{ fontSize: "0.85em", opacity: "0.8" }}>Join your virtual coaching session</div>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div style={{
            maxWidth: "700px",
            margin: "0 auto 40px",
            padding: "25px",
            backgroundColor: "rgba(27, 31, 34, 0.85)",
            borderRadius: "10px",
            border: "1px solid rgba(255, 255, 255, 0.2)"
          }}>
            <h3 style={{
              marginTop: "0",
              marginBottom: "20px",
              color: "#FF5722",
              textAlign: "center",
              fontSize: "1.3em"
            }}>
              Questions?
            </h3>
            <div style={{ fontSize: "0.95em", lineHeight: "1.8", opacity: "0.9" }}>
              {/* <p style={{ marginBottom: "15px" }}>
                <strong>What platform do we use?</strong><br />
                We use Zoom for all virtual training sessions. You'll receive a link after booking.
              </p>
              <p style={{ marginBottom: "15px" }}>
                <strong>How do I redeem my premium code?</strong><br />
                Open the Range Drills app, go to Settings → Promo Code, and enter the code we email you.
              </p> */}
              <p style={{ marginBottom: "0" }}>
                {/* <strong>Can I reschedule?</strong><br /> */}
                Contact us at <a href="mailto:info@rangedrills.io" style={{ color: "#FF5722", textDecoration: "none" }}>info@rangedrills.io</a> and let us help you get started.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Store;
